import React from 'react';
import { ShopScreen } from 'features/shop-base/ShopScreen';
import { HomepageView } from 'features/homepage/contexts/contentful';
import { HomePageRenderer } from 'features/homepage/HomePageRenderer';

export const HomepageScreen = () => {
    return (
        <ShopScreen>
            <HomepageView>
                <HomePageRenderer />
            </HomepageView>
        </ShopScreen>
    );
};
